import type { ModelCatalog } from "./schema";

export async function loadCatalog(bedId: string): Promise<ModelCatalog> {
  const url = `./models/${bedId}.json`;
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`Catalog not found: ${url} (HTTP ${res.status})`);
  }
  const data = (await res.json()) as ModelCatalog;
  if (data.id !== bedId) {
    console.warn(
      `Catalog id mismatch: file is "${data.id}", expected "${bedId}".`,
    );
  }
  return data;
}
